import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const SearchContext = createContext(null);

export const SearchProvider = ({ children }) => {
    const [query, setQuery] = useState('');
    const [sectionLabel, setSectionLabel] = useState('');
    const handlerRef = useRef(null);

    const registerSearchHandler = useCallback((label, handler) => {
        setSectionLabel(label);
        handlerRef.current = handler;
        return () => {
            if (handlerRef.current === handler) {
                handlerRef.current = null;
                setSectionLabel('');
            }
        };
    }, []);

    const searchInSection = useCallback((q) => {
        if (handlerRef.current) return handlerRef.current(q);
        return [];
    }, []);

    return (
        <SearchContext.Provider value={{ query, setQuery, sectionLabel, registerSearchHandler, searchInSection }}>
            {children}
        </SearchContext.Provider>
    );
};

export const useSearch = () => {
    const ctx = useContext(SearchContext);
    if (!ctx) throw new Error('useSearch must be used within SearchProvider');
    return ctx;
};
